<template>
  <div>
    <v-dialog v-model="dialogInputServiceCharge" width="500" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Service Charge</v-card-title>
        <v-card-text>
          <v-form
            @submit.prevent="handleSubmit"
            style="padding:20px;"
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              type="number"
              v-model="partner_service_charge"
              label="Service Charge"
              :rules="[rules.required, rules.max]"
              outline
            ></v-text-field>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" type="submit" large :disabled="!valid">SAVE</v-btn>
              <v-btn color="red" class="white--text" large @click="cancelSubmit">CANCEL</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["dialogInputServiceCharge"],
  data() {
    return {
      partner_service_charge: 0,
      statusBtn: "",
      valid: true,
      rules: {
        required: (v) => !!v || "กรุณากรอกข้อมูล",
        max: (v) => v <= 999 || "Limit Charge must less than 1000",
      },
    };
  },
  methods: {
    async handleSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit("save", this.partner_service_charge);
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }
    },
    cancelSubmit() {
      this.$emit("cancel");
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
  },
};
</script>
